import { Field, ErrorMessage, useFormikContext } from 'formik';

import Icon from '../Icon';
import styles from './Stars.module.scss';

const Stars = ({ className, loading, count }) => {

  const { values: { stars }, setFieldValue } = useFormikContext();

  const ITEMS = Array.from({ length: count }, (_, i) => i + 1);

  return (
    <div className={`${styles.root} ${className || ''}`}>
      <Field
        id='stars'
        type='hidden'
        name='stars'
      />

      {
        ITEMS.map(item => (
          <button
            key={item}
            type='button'
            className={`${item <= stars ? styles.active : ''}`}
            onClick={() => setFieldValue('stars', item)}
            aria-label={`${item} ${item === 1 ? 'star' : 'stars'}`}
            disabled={loading} >

            <Icon name='star' />

          </button>
        ))
      }

      <ErrorMessage
        className={styles.error}
        name='stars'
        component='div'
      />
    </div>
  );
};

export default Stars;